import React, { Component } from 'react';
import { base } from '../../base';
import '../../styles/css/Scoreboard.css';
import { motion } from "framer-motion";
import {Column, Row} from "simple-flexbox";
import { Textfit } from 'react-textfit'

class Scoreboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionIndex: 0,
            hintIndex: 0,
            blurPixels: 50,
            alreadyStartedProcess: false,
            blurImageWidth: 0,
            defaultDeblurTime: 30,
            loading: true,
            startAnimating: true,
            currentGame: {},
            tenantVariables: {},
            showAnswer: false,
            finishedQuestionRotation: false
        };
        this.hintInterval   = null;
        this.deblurInterval = null;
        this.finishTimeout  = null;
    }

    componentDidMount(){
        document.title = "Scoreboard";
        this.tenantVariablesRef = base.listenTo(`tenantVariables`, {
            context: this,
            then(variables){
                let amountToBlur = variables.startingBlurAmount || 50;
                if(this.state.currentGame && this.state.currentGame.status === 1){
                    amountToBlur = this.state.blurPixels;
                }
                this.setState({
                    blurPixels: amountToBlur,
                    tenantVariables: variables
                })
            }
        });
        this.currentGameRef = base.listenTo(`currentGame`, {
            context: this,
            then(data){
                this.setState({
                    currentGame: data,
                    loading: false
                })
                if(data && data.status && parseInt(data.status) === 1 && this.state.finishedLoadingBlurredImage){
                    this.startDeblurProcess();
                }
            }
        })
    }

    componentWillUnmount() {
        base.removeBinding(this.currentGameRef);
        base.removeBinding(this.tenantVariablesRef);
        if (this.hintInterval)   clearInterval(this.hintInterval);
        if (this.deblurInterval) clearInterval(this.deblurInterval);
        if (this.finishTimeout)  clearTimeout(this.finishTimeout);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState && prevState.currentGame && prevState.currentGame.status === 1 && this.state.currentGame && this.state.currentGame.status === 0){
            const amountToBlur = this.state.tenantVariables.startingBlurAmount || 50;
            if (this.hintInterval)   clearInterval(this.hintInterval);
            if (this.deblurInterval) clearInterval(this.deblurInterval);
            this.hintInterval   = null;
            this.deblurInterval = null;
            this.setState({
                questionIndex: 0,
                hintIndex: 0,
                alreadyStartedProcess: false,
                finishedQuestionRotation: false,
                blurPixels: amountToBlur
            })
        }
    }

    startDeblurProcess(){
        if(this.state.alreadyStartedProcess){
            console.log("AKREADY STE")
            return;
        } else if(!this.state.currentGame || this.state.currentGame.status !== 1){
            console.log("INSIDE CURRENT GAME")
            return;
        }
        this.setState({alreadyStartedProcess: true})
        const { questionIndex=0, currentGame={}, tenantVariables={}, hintIndex=0 } = this.state;
        const deblurTime = tenantVariables.timeToDeblur || this.state.defaultDeblurTime;
        const questions = currentGame.questions || [];
        if(questions.length === 0){
            console.log("NO QUESTIONS!")
            return
        }
        this.showQuestionAndGoThroughHints(questions, deblurTime, questionIndex, hintIndex);
    }

    showQuestionAndGoThroughHints(questions, deblurTime, questionIndex, hintIndex) {
        // tear down any old loops
        if (this.hintInterval)   clearInterval(this.hintInterval);
        if (this.deblurInterval) clearInterval(this.deblurInterval);
        if (this.finishTimeout)  { clearTimeout(this.finishTimeout); this.finishTimeout = null; }

        const initialBlur = this.state.tenantVariables.startingBlurAmount ?? 50;
        this.setState({ blurPixels: initialBlur });
        const currentQuestion = questions[questionIndex] || {};
        const hints          = currentQuestion.hints || [];
        let   pixelsLeft     = initialBlur;
        const step           = pixelsLeft / deblurTime;

        if (hints.length > 1) {
            let localHintIdx = hintIndex;
            const hintMs     = (deblurTime / hints.length) * 1000;
            this.hintInterval = setInterval(() => {
                localHintIdx++;
                if (localHintIdx >= hints.length) {
                    clearInterval(this.hintInterval);
                    this.hintInterval = null;
                } else {
                    this.setState(prev => ({
                        hintIndex:      localHintIdx,
                        startAnimating: !prev.startAnimating
                    }), () => {
                        this.setState({ startAnimating: true });
                    });
                }
            }, hintMs);
        }

        this.deblurInterval = setInterval(() => {
            pixelsLeft -= step;
            this.setState({ blurPixels: Math.max(3, pixelsLeft) });

            if (pixelsLeft <= 3) {
                // stop the blur loop
                clearInterval(this.deblurInterval);
                this.deblurInterval = null;

                // are we on the last question?
                const lastQ = (questionIndex === questions.length - 1);

                if (lastQ) {
                    // immediately show the final answer—no hide/timer
                    this.setState({ finishedQuestionRotation: true });
                } else {
                    // the per-question reveal path
                    this.setState({ showAnswer: true }, () => {
                        const pauseMs = this.state.tenantVariables.answerDisplayTime || 5000;
                        this.finishTimeout = setTimeout(() => {
                            clearTimeout(this.finishTimeout);
                            this.finishTimeout = null;

                            // hide answer + advance
                            this.setState(
                                { showAnswer: false, questionIndex: questionIndex + 1, hintIndex: 0 },
                                () => this.showQuestionAndGoThroughHints(
                                    questions, deblurTime, questionIndex + 1, 0
                                )
                            );
                        }, pauseMs);
                    });
                }
            }
        }, 1000);
    }

    blurImageFinishedLoading(){
        const img = document.getElementById('imageToBlur');
        let blurImageWidth = 0;
        if(img && img.width){
            blurImageWidth = img.width;
        }
        this.setState({
            finishedLoadingBlurredImage: true,
            blurImageWidth: blurImageWidth
        }, () => {
            this.startDeblurProcess();
        })
    }

    render() {
        const {
            currentGame={},
            tenantVariables={},
            questionIndex=0,
            hintIndex=0,
            finishedQuestionRotation=false,
            showAnswer=false,
            blurPixels = 50,
            blurImageWidth = 0
        } = this.state;
        let hintTextLabel = tenantVariables.hintTextLabel || "HINT";
        const questions = currentGame.questions || [];
        let winnerImage = "";
        let currentQuestion = {};
        if(questions.length > 0){
            currentQuestion = questions[questionIndex] || questions[0] || {};
            for(const questionIndex in currentQuestion.answers){
                if(currentQuestion.answers[questionIndex].correct){
                    winnerImage = currentQuestion.answers[questionIndex].answerImage;
                }
            }
        }
        const backgroundImage = tenantVariables.scoreboardBackgroundImage;
        const winnerAnswer  = (currentQuestion.answers || []).find(a => a.correct)?.answerImage;
        return (
            <div className="flex-container-home" style={{backgroundImage: "url(" + backgroundImage + ")", height: '100vh', overflow: 'hidden'}}>
                <svg className='hideSvgSoThatItSupportsFirefox'>
                    <filter id='sharpBlur'>
                        <feGaussianBlur stdDeviation={this.state.blurPixels}/>
                        <feColorMatrix type='matrix' values='1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0'/>
                        <feComposite in2='SourceGraphic' operator='in'/>
                    </filter>
                </svg>
                <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
                <Row>
                    <Column style={{width:"50%", height: "100vh"}}>
                        <Row horizontal="center" vertical="center" style={{height: "50%", maxHeight: "50%"}}>
                            <img src={tenantVariables.sponsorImage} alt="" style={{maxHeight: "100%", maxWidth: "100%", height:"auto", width:"auto", padding: 20}}/>
                        </Row>
                        <Column
                            horizontal="center"
                            style={{ height: '10vh', maxHeight: '10vh' }}
                            className="addFont"
                        >
                            <Textfit mode="single" min={12} max={60} style={{
                                width: '100%',
                                height: '100%',
                                color: tenantVariables.hintColor || '#000',
                                textAlign: 'center'
                            }}>
                                {hintTextLabel}
                            </Textfit>
                        </Column>

                        {/* HINT BODY (multiline fit) */}
                        <Column
                            horizontal="center"
                            vertical="center"
                            style={{ height: '40vh', maxHeight: '40vh' }}
                            className="addFont"
                        >
                            <Textfit mode="multi" min={14} max={80} style={{
                                width: '100%',
                                height: '100%',
                                padding: '0 10px',
                                color: tenantVariables.scoreboardHintColor || '#000'
                            }}>
                                <motion.div initial={{ x: "-30vw", opacity: 0 }} animate={{ x: 0, opacity: 1 }}>
                                    {currentQuestion.hints?.[hintIndex]?.hintText}
                                </motion.div>
                            </Textfit>
                        </Column>
                    </Column>
                    {(!finishedQuestionRotation && !showAnswer) ? (
                        <Column horizontal="end" style={{ width: "50%", height: "100vh" }}>
                            <div style={{ overflow: "hidden" }}>
                                <img
                                    id="imageToBlur"
                                    className="svgBlur mbs"
                                    onLoad={() => this.blurImageFinishedLoading()}
                                    src={currentQuestion.gifSelectionImage}
                                    alt=""
                                    style={{
                                        maxHeight: "100vh",
                                        height: "100%",
                                        width: "auto",
                                        maxWidth: "100%",
                                        filter: `blur(${blurPixels}px)`
                                    }}
                                />
                            </div>
                        </Column>
                    ) : (
                        // 2) Answer (either per-question or final)
                        <Column horizontal="end" vertical="center" style={{ width: "50%", height: "100vh", paddingRight: '1%' }}>
                            <img
                                className="fade-in-image"
                                src={winnerAnswer}
                                alt=""
                                style={{
                                    maxHeight: "100vh",
                                    height: "auto",
                                    width: blurImageWidth,
                                    maxWidth: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        </Column>
                    )}
                </Row>
            </div>
        );
    }
}

export default Scoreboard;
